module.exports = __webpack_public_path__ + "img/hero-02.13f8f722.jpg";